module.exports = __webpack_public_path__ + "static/32-5d235be296a7fbd1257359fcbd1bfa29.mp4";